import { StrictNullable } from '@/shared/types/app.types'
import { Dictionary } from 'vue-router/types/router'
import { ImageInfo, WMTSImageInfo } from './viewer/Viewer.models'

export const BROADCAST_ATTACHMENT_UPDATED_CHANNEL = 'attachmentUpdateChannel'
export const BROADCAST_ATTACHMENT_UPDATED_CHANNEL_MESSAGE = 'attachmentUpdated'

export enum ViewerType {
    STATIC_VIEWER = 'STATIC',
    WSI_VIEWER = 'WSI'
}
export interface AttachmentInfo {
    laboratoryId: number
    caseId: number
    sampleId: number
    portionId: number
    subportionId: number
    attachmentId: number | undefined
    viewerType: ViewerType
    imageInfo: ImageInfo
    wmtsImageInfo: WMTSImageInfo
}

export interface IViewerModuleState {
    showTreeNavigation: boolean
    attachmentInfo: AttachmentInfo | null
    annotationId?: string
    query?: Dictionary<string | StrictNullable<string>[]>
    selectedColor: string
    flagChanges:boolean
}
export const initialViewerModuleState =
    (): IViewerModuleState => ({
        showTreeNavigation: false,
        attachmentInfo: null,
        selectedColor: 'red',
        flagChanges: false
    })
